module.exports = __webpack_public_path__ + "img/40_38_032_720.9e0ecf5c.jpg";